import { isAfter, startOfDay } from "date-fns";
import { invoice_statuses } from "@/models/invoice.model";

export type CustomerInvoiceStatus = "Due" | "Overdue" | "Paid" | "Void";

export function customerInvoiceStatus(status: invoice_statuses, dueDate: string, today: Date): CustomerInvoiceStatus {
  if (status === invoice_statuses.paid) return "Paid";
  if (status === invoice_statuses.void) return "Void";
  return isAfter(startOfDay(today), startOfDay(new Date(dueDate))) ? "Overdue" : "Due";
}
